export default function ResponseTimeIcon({ width = 22, height = 22, ...rest }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 22 22' fill='none' {...rest}>
      <g clipPath='url(#response-time-clip)'>
        <path
          d='M11 5.54297V11.0012H15.4'
          stroke='currentColor'
          strokeWidth='2.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.8958 1.13007C8.1468 1.32637 6.48175 1.98537 5.07214 3.0392C3.66254 4.09302 2.55935 5.50359 1.87619 7.12557C1.19305 8.74756 0.954648 10.5223 1.18555 12.2671C1.41645 14.0119 2.1083 15.6636 3.18984 17.052C4.27139 18.4405 5.70352 19.5155 7.33871 20.1664C8.97391 20.8173 10.7531 21.0205 12.4929 20.7551C14.2328 20.4897 15.8704 19.7652 17.2372 18.6564C18.604 17.5476 19.6504 16.0944 20.2688 14.4467'
          stroke='currentColor'
          strokeWidth='2.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20.9002 10.9704C20.9002 10.2248 20.8177 9.49847 20.6615 8.79999'
          stroke='currentColor'
          strokeWidth='2.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M18.0319 4.0004C18.5449 4.51795 19.0012 5.09184 19.3907 5.71195'
          stroke='currentColor'
          strokeWidth='2.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.3246 1.34491C14.0598 1.52179 14.763 1.78071 15.424 2.11145'
          stroke='currentColor'
          strokeWidth='2.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='response-time-clip'>
          <rect width='22' height='22' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
